import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import { Button } from '@doltech/ui/lib/figma/ButtonV2/ButtonV2';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ReadingText, SubText } from '@doltech/ui/lib/figma/Typography';
import * as React from 'react';
import styled from 'styled-components';

const QUESTION_HEIGHT = '36px';
const QUESTION_WIDTH = 'minmax(36px, 1fr)';

export const QuestionList = styled.div`
  margin-top: 4px;
  display: grid;
  row-gap: 8px;
  column-gap: 12px;
  align-items: center;
  grid-template-rows: repeat(auto-fill, ${QUESTION_HEIGHT});
  grid-template-columns: repeat(auto-fill, ${QUESTION_WIDTH});
  grid-auto-columns: ${QUESTION_WIDTH};
  grid-auto-rows: ${QUESTION_HEIGHT};
`;
export const QuestionGroupList = styled.div`
  margin-top: 8px;
`;

export const DivQuestionBox = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colorsV2.black80};
  background-color: ${colorsV2.gray20};
  border-radius: 50%;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  &.active {
    color: ${colorsV2.white100};
    background-color: ${colorsV2.blue100};
  }
  &.disabled {
    background: ${colorsV2.gray40};
  }
`;

export const ButtonFooter = styled.div`
  left: 0;
  height: 80px;
  width: 100%;
  background: ${colorsV2.white100};
  padding: 16px;
  position: fixed;
  bottom: 0;
  button {
    width: 100%;
  }
`;

export const BodyWrapper = styled.div`
  padding: 0 16px 16px;
  .reading-text {
    font-size: 10px;
    font-weight: 600;
  }
  .ant-tabs-nav {
    width: calc(100vw - 32px);
    position: absolute;
    background: ${colorsV2.white100};
    z-index: 1;
  }
  .ant-tabs-content {
    padding-top: 66px;
  }
  .ant-tabs-tab {
    padding: 24px 16px 16px;
    margin: 0;
  }
  .test-section-wrapper {
    &:not(:first-child) {
      .section-questions {
        margin-top: 24px;
      }
    }
  }
`;

interface OverallTitleProps {
  title: string;
  subTitle?: string;
  onClose?: () => void;
}

const OverallTitleMain = styled.div`
  display: flex;
  .section-left {
    flex: 1;
    .reading-text {
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
    }
    .sub-text {
      font-size: 13px;
    }
  }
  .section-right {
    height: 48px;
    font-size: 48px;
    width: 24px;
  }
`;

const CloseSwiper = styled.div`
  width: 68px;
  height: 4px;
  background: ${colorsV2.black100};
  border-radius: 180px;
  margin: 0 auto;
  margin-top: -8px;
  margin-bottom: 12px;
`;

export const OverallTitle = ({ title, subTitle, onClose }: OverallTitleProps) => {
  return (
    <div>
      <CloseSwiper />
      <OverallTitleMain className="overall-title">
        <div className="section-left">
          <ReadingText block>{title}</ReadingText>
          {subTitle && <SubText block>{subTitle}</SubText>}
        </div>
        <div className="section-right">
          <Button.Icon type="secondary" size="small" onClick={onClose}>
            <IconOtherClose fontSize={20} />
          </Button.Icon>
        </div>
      </OverallTitleMain>
    </div>
  );
};
